import { pathOr } from 'ramda'
import {
  VALIDATOR_EMAIL,
  VALIDATOR_PHONE,
  VALIDATOR_REQUIRED,
  VALIDATOR_CARD_NUMBER_15,
  VALIDATOR_CARD_NUMBER_16,
  VALIDATOR_EXPIRES,
  VALIDATOR_CVV_3,
  VALIDATOR_CVV_4,
  VALIDATOR_CHARACTERS,
} from '../../shared/FormControls/CoreValidators'

import {
  SEARCH_PARAM_CLIENT_CODE,
  SEARCH_PARAM_CONTRACT_NUMBER,
  SEARCH_PARAM_IATA_CODE,
  SEARCH_PARAM_PROMO_CODE,
} from '../../search/constants'

export const SNW_FACEBOOK = 'facebook'
export const SNW_GOOGLE_PLUS = 'googlePlus'
export const SNW_TWEETER = 'tweeter'
export const SNW_INSTAGRAM = 'instagram'

const settingsPath = ['drupalSettings', 'booking', 'secondStep']

export const basket = pathOr(
  {
    searchQuery: {
      apartment: ['2,0,0,yyHc21gQS'],
      dateIn: '2018-09-28',
      geoCode: 'V2996',
      geoType: 'VI',
      hotel_id: '6786',
      nbNight: '2',
      q: 'Paris, Ile-de-France, France',
      roomId: 'AR4P',
      roomRateId: '1KD',
    },
  },
  [...settingsPath, 'basket'],
  window,
)

export const stepTitle = pathOr(
  'Your booking step',
  [...settingsPath, 'stepTitle'],
  window,
)

export const pageTitle = pathOr(
  'Complete your booking',
  [...settingsPath, 'pageTitle'],
  window,
)

export const loginBlock = pathOr(
  {
    tab1: {
      label: 'Are you new to Adagio?',
      guestBlock: {
        title: 'Continue as a guest',
        description: 'OR',
        subtitle: 'Create you account for free and take advantage of <span>5% of reduction </span>!!',
        titleDescription: 'Input your e-mail and finalise your booking without creating an account',
        loginBtn: 'Continue',
        fields: {
          guestEmail: {
            validate: [VALIDATOR_EMAIL, VALIDATOR_REQUIRED],
            placeholder: 'Email',
            value: "test@test.tets",
          },
          register: {
            value: 'Sign-up',
            href: '#sign-up',
          },
        },
      },
    },
    tab2: {
      label: 'Already registered ?',
      title: 'Login to your account',
      socialBlock: {
        description: 'Connection with a social account is ultra fast and convenient.',
        buttons: {
          facebook: {
            href: '#2fb',
          },
          googlePlus: {
            href: '#2g+',
          },
          tweeter: {
            href: '#2tw',
          },
          instagram: {
            href: '#2insta',
          },
        },
      },
      connectBlock: {
        fields: {
          loginEmail: {
            validate: [VALIDATOR_EMAIL, VALIDATOR_REQUIRED],
            placeholder: 'Email',
          },
          connect: {
            href: '#connection',
            value: 'Connection',
          },
        },
      },
    },
  },
  [...settingsPath, 'loginBlock'],
  window,
)

export const yourDataBlock = pathOr(
  {
    title: 'Your details',
    subTitle: 'Member at a detail near',
    description: 'Confirm that you want to join ALL - Accor Live Limitless and get 10% discount on all your bookings.'
      + ' Try it, it`s free.',
    block10Percent: {
      available: false,
      upTo: 'up to',
      description: 'With this booking, you save 130 € and accumulate 300 points. Registration is completely free.',
      fields: {
        discountAgreement: {
          agreeAndAccept: 'I agree and I accept',
          generalConditions: 'general conditions of use',
          generalConditionsHref: '#general-conditions',
          validate: undefined,
        },
        discountPassword: {
          placeholder: 'Password',
          validate: undefined, // todo
        },
      },
      messageBox: {
        title: 'Warning',
        description: 'If you do not wish to become a member of Club Accor Hotel, you will not benefit from our 10% discount.',
        buttonText: 'I understood',
        available: false,
      },
    },
    blockForm: {
      title: 'Personal informations',
      noResultsText: 'No results found',
      editLabel: 'Éditer',
      codeLabel: 'Booking made by:',
      fields: { // setting prefiling data here (value parameter => comment/uncomment)
        title: {
          placeholder: 'Civility',
          options: [
            {
              value: null,
              label: 'Select a value',
            },
            {
              value: '1',
              label: 'Mr.',
            },
            {
              value: '2',
              label: 'Mrs.',
            },
            {
              value: '3',
              label: 'Ms.',
            },
          ],
          validate: [VALIDATOR_REQUIRED],
          // value: '1',
        },
        firstName: {
          placeholder: 'Fistname',
          validate: [VALIDATOR_CHARACTERS],
          value: 'Jhon',
        },
        lastName: {
          placeholder: 'Lastname',
          validate: [VALIDATOR_CHARACTERS],
          // value: 'Doe',
        },
        mobile: {
          placeholder: 'Mobile',
          validate: [VALIDATOR_PHONE, VALIDATOR_REQUIRED],
          value: '',
          countryCode: 'FR',
        },
        nationality: {
          placeholder: 'Nationality',
          options: [
            {
              value: null,
              label: 'Select a value',
            },
            {
              value: '1',
              label: 'French',
            },
            {
              value: '2',
              label: 'English',
            },
            {
              value: '3',
              label: 'Russian',
            },
            {
              value: '4',
              label: 'Spanish',
            },
            {
              value: '5',
              label: 'Italian',
            },
          ],
          validate: [VALIDATOR_REQUIRED],
          // value: '3',
        },
        country: {
          placeholder: 'Country',
          options: [
            {
              value: null,
              label: 'Select a value',
            },
            {
              value: 'FR',
              label: 'France',
            },
            {
              value: 'RU',
              label: 'Russia',
            },
            {
              value: 'RO',
              label: 'Romania',
            },
            {
              value: 'ES',
              label: 'Spain',
            },
          ],
          validate: [VALIDATOR_REQUIRED],
          // value: 'ES',
        },
        address: {
          placeholder: 'Address',
          validate: [VALIDATOR_REQUIRED],
          // value: 'Address',
        },
        city: {
          placeholder: 'City',
          validate: [VALIDATOR_REQUIRED],
          // value: 'City',
        },
        region: {
          placeholder: 'State',
          validate: [VALIDATOR_REQUIRED],
          selectValueOption: {
            value: null,
            label: 'Select a value',
          },
          options: {
            FR: [
              {
                value: 'FR1',
                label: 'France, state 1',
              },
              {
                value: 'FR2',
                label: 'France, state 2',
              },
              {
                value: 'FR3',
                label: 'France, state 3',
              },
            ],
            RU: [
              {
                value: 'RU1',
                label: 'Russia, state 1',
              },
              {
                value: 'RU2',
                label: 'Russia, state 2',
              },
              {
                value: 'RU3',
                label: 'Russia, state 3',
              },
            ],
            RO: [],
            ES: [
              {
                value: 'ES1',
                label: 'Spain, state 1',
              },
              {
                value: 'ES2',
                label: 'Spain, state 2',
              },
              {
                value: 'ES3',
                label: 'Spain, state 3',
              },
            ],
          },
          // value: 'ES1',
        },
        zipCode: {
          placeholder: 'Zip code',
          cardTypes: ['ax'],
          validate: [VALIDATOR_REQUIRED],
          // value: '001100',
        },
        tripReason: {
          label: 'What is the reason of your trip ?',
          radioButtons: [
            {
              label: 'Pleasure',
              value: 'PLEASURE',
            },
            {
              label: 'Business',
              value: 'BUSINESS',
            },
          ],
        },
        guestEmail: {
          value: 'qwe@qwe.qwe',
        },
      },
    },
  },
  [...settingsPath, 'yourDataBlock'],
  window,
)

export const detailInfoBlock = pathOr(
  {},
  [...settingsPath, 'detailInfoBlock'],
  window,
)

export const paymentDetailsBlock = pathOr(
  {
    title: 'Payment details',
    mandatoryField: 'Mandatory field',
    notice: {
      text: 'Choose your payment method.',
      linkText: 'You will not be charged. This step only validates your reservation.',
      linkHref: '#about-the-charges',
    },
    paymentMethod: {
      radioLabels: {
        viaCard: 'Pay by card',
        viaPayPal: 'Pay with Paypal',
      },
    },
    blocks: {
      promoBlock: {
        title: 'Do you have a promo code ?',
        fields: {
          promoCode: {
            placeholder: 'Enter your code',
            value: '',
          },
        },
        button: 'Apply',
        buttonDelete: 'Delete',
      },
      cardBlock: {
        fields: {
          cardType: {
            placeholder: 'Selected card',
            options: [
              {
                value: 'CA',
                label: 'Master Card',
                className: 'CA',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'VI',
                label: 'Visa',
                className: 'VI',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'AX',
                label: 'American Express',
                className: 'AX',
                cardNumber: {
                  mask: '9999 999999 99999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_15],
                },
                cardCVV: {
                  mask: '9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_4],
                },
              },
              {
                value: 'DC',
                label: 'Diners Club',
                className: 'DC',
                cardNumber: {
                  mask: '9999 999999 99999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_15],
                },
                cardCVV: {
                  mask: '9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_4],
                },
              },
              {
                value: 'AK',
                label: 'Accor Business Account',
                className: 'AK',
                cardNumber: {
                  mask: '9999 999999 99999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_15],
                },
                cardCVV: {
                  mask: '9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_4],
                },
              },
              {
                value: 'VI2X',
                label: 'Visa Parcelamento 2x',
                className: 'VI2X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'VI3X',
                label: 'Visa Parcelamento 3x',
                className: 'VI3X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'VI4X',
                label: 'Visa Parcelamento 4x',
                className: 'VI4X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'VI5X',
                label: 'Visa Parcelamento 5x',
                className: 'VI5X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'VI6X',
                label: 'Visa Parcelamento 6x',
                className: 'VI6X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'CA2X',
                label: 'Mastercard Parcelamento 2x',
                className: 'CA2X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'CA3X',
                label: 'Mastercard Parcelamento 3x',
                className: 'CA3X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'CA4X',
                label: 'Mastercard Parcelamento 4x',
                className: 'CA4X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'CA45',
                label: 'Mastercard Parcelamento 5x',
                className: 'CA5X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
              {
                value: 'CA6X',
                label: 'Mastercard Parcelamento 6x',
                className: 'CA6X',
                cardNumber: {
                  mask: '9999 9999 9999 9999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
                },
                cardCVV: {
                  mask: '999',
                  validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
                },
              },
            ],
            validate: [VALIDATOR_REQUIRED],
          },
          cardHolderName: {
            placeholder: 'Name of holder',
            validate: [VALIDATOR_CHARACTERS],
          },
          cardNumber: {
            placeholder: 'Number',
            validate: [VALIDATOR_REQUIRED, VALIDATOR_CARD_NUMBER_16],
          },
          cardExpires: {
            placeholder: 'Expires on',
            validate: [VALIDATOR_REQUIRED, VALIDATOR_EXPIRES],
          },
          cardCVV: {
            placeholder: 'CVV',
            validate: [VALIDATOR_REQUIRED, VALIDATOR_CVV_3],
          },
          /**
           * Hidden for MVP
           */
          saveCardData: {
            placeholder: 'Save my payment method',
          },
        },
        notice: {
          text: 'By confirming your reservation, you accept the',
          linkText: 'General Conditions of Adagio.',
          linkHref: '#general-conditions',
        },
      },
    },
    fields: {
      subscribeNewsletter: {
        label: 'I want to subscribe to the Adagio newsletter',
      },
    },
  },
  [...settingsPath, 'paymentDetailsBlock'],
  window,
)

export const confirmReservationBlock = pathOr(
  {
    fields: {
      sendEmails: {
        label: 'I wish to receive commercial electronic messages on behalf of Adagio SAS',
      },
    },
    basket: {
      buttonUrl: '/booking/confirmation/{bookingId}',
      text: 'Book',
    },
  },
  [...settingsPath, 'confirmReservationBlock'],
  window,
)

export const secondStepApiUrls = pathOr(
  {
    secondStep: 'https://5b3a1a5a356f570014d0baa0.mockapi.io/submit-second-step',
    promoCode: 'https://5b3a4a4e356f570014d0bb20.mockapi.io/adagio/api/v1/promo_code',
  },
  [...settingsPath, 'api'],
  window,
)

export const secondStepMeta = pathOr(
  {
    basketId: 'xyz',
    roomCode: 'abc',
    offerCode: 'zxc',
  },
  [...settingsPath, 'meta'],
  window,
)

export const rooms = pathOr(
  {
    rates: {
      roomId: 2,
      conditionsURL: '/conditions.json',
      hotelId: '7329',
      link: 'See conditions',
      second_title: 'Detail that makes the difference',
      title: 'Choose your rate',
    },
  },
  ['drupalSettings', 'rooms'],
  window,
)


export const proxyUserClick = (event, path) => {
  const onClick = pathOr((e) => {
    e.preventDefault()
  }, path, loginBlock)
  onClick(event)
}

export const callMeBack = pathOr(
  "<div class=\"webcallback\"><div id=\"buttonC2cId-9512274fcv13966138\"><img id=\"imgBtnCplusRc9512274fcv13966138\" src=\"https://cplusrc3.internetpluspro.orange-business.com/popImages/9250835for139661/9512274fcv13966138/bouton.jpg\" onmouseover=\"this.style.cursor='pointer'\" onclick=\"openLinkSite9512274fcv13966138();\" style=\"z-index: 9997; cursor: pointer;\" /></div><script type=\"text/javascript\">\n<!--//--><![CDATA[// ><!--\nvar v1 = \"summary\", v2 = \"en\", v3 = \"home\", v4 = \"6790\";\n//--><!]]>\n</script><script type=\"text/javascript\" src=\"https://c2cu.internetpluspro.orange-business.com/c2call-frontend/button/button.html?s=9512274fcv13966138&amp;c=9250835for139661\"></script></div>",
  ['drupalSettings', 'callMeBack', 'api', 'callMeBack'],
  window,
)

export const loginBlockSearch = pathOr(
  {
    tab2: {
      connectBlock: {
        fields: {
          connect: {
            href: '#connection',
            value: 'Connection',
          },
        },
      },
    },
  },
  ['drupalSettings', 'loginBlock'],
  window,
)

export const dataLayerPayment = pathOr({
  basketid: '6789-38e45398-7b24-485f-a0b4-dda7f874e366',
  brandcontext: 'ADAGIO',
  countrymarket: 'fr',
  currencycode: 'EUR',
  hoteladdress: '1-7 Cour du Minervois 75012 PARIS',
  hotelamenities: 'ANIMALS | REDUCEDMOBILITY | INTERNET | HOTELFACILITIES | BUSINESS | MEETING | E_WLC | AIRCONDITIONING',
  hotelbrandcode: 'ADG',
  hotelbrandname: 'ADAGIO',
  hotelcitycode: 'SI44',
  hotelcityname: 'PARIS',
  hotelcode: '6789',
  hotelcountrycode: 'FR',
  hotelcountryname: 'FRANCE',
  hotelcurrencycode: 'EUR',
  hotelname: 'Aparthotel Adagio Paris Bercy Village',
  hotelnumberoftripadvisorreviews: '453',
  hotelstarnumber: 4,
  hoteltripadvisorrating: 4,
  isbooker: false,
  jsessionid: 'uQ7Z8g8d5117OJWaHhHQ1nBYEDCUepO6vpaJb26yQRc',
  orderamount: {
    countryvalue: '172.76',
    hotelvalue: '172.76',
    value: '172.76',
  },
  pagename: 'booking::step3identification',
  pagepath: '/fr/booking/payment',
  reviewsprovider: 'TRIPADVISOR',
  roomprice1: {
    countryvalue: '155.45',
    hotelvalue: '155.45',
    value: '155.45',
  },
  roomprice1withoptions: {
    countryvalue: '172.76',
    hotelvalue: '172.76',
    value: '172.76',
  },
  roomtype1: 'Studio pour 2 personnes',
  searchcriteriaarrivaldate: '27-09-2018',
  searchcriteriadeparturedate: '28-09-2018',
  searchcriterianumberadult: 2,
  searchcriterianumberchildren: 0,
  searchcriterianumbernights: 1,
  searchcriterianumberrooms: 1,
  tarsoffercode: ['RA3AD1'],
  tarsproductcode: ['CA2P'],
  uilogged: false,
  userconsent: true,
}, ['drupalSettings', 'dataLayer', 'payment'], window)

export const searchResults = pathOr({
  brand_statement: [
    {
      image_link: '/brandingStatement/BG.svg',
      text: 'Paris, Aisne1',
      href: '?geoCode=V89320&geoType=VI',
    },
    {
      image_link: '/brandingStatement/BG.svg',
      text: 'Paris, Aisne2 <a href="#log-in">login</a>',
      href: '?geoCode=V89321&geoType=VII',
    },
    {
      image_link: '/brandingStatement/BG.svg',
      text: 'Paris, Aisne3',
      href: '?geoCode=V89323&geoType=VIII',
    },
  ],
  code: {
    companyName: 'Google inc.',
    companyLabel: 'Entreprise',
    loyaltyCard: '082T6VHC26453298',
    loyaltyLabel: 'Carte de fidélité',
    image_link: '/brandingStatement/BG.svg',
  },
  results: [
    {
      id: 1,
      title: '[FROM DS] Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 5,
      rating: {
        value: '3.6',
        total: 174,
      },
      hotelLink: '#hotelLink',
      reserveBtnUrl: 'https://html.adagio.adyax-dev.com/first-step.html',
      coordinates: {
        lat: 52.0808361,
        lng: 33.7107032,
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      featureImages: [
        {
          className: 'icon-ANIMALS',
          label: 'Ouvert 24H/24 7J/7 toute l’année',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
          label: 'Ouvert 24H/24 7J/7 toute l’année',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
      ],
      price: '21.80€',
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      from: 'From',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus Altus tatas ducunt ad candidatus. Altus tatas ducunt ad candidatus. Altus tatas ducunt ad candidatus. Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: true,
      unavailableText: 'No appartement available for those dates',
      isFavorite: true,
      offerBanner: {
        date: 'From 11 Dec. to 24 Feb.',
        text: 'Banner description',
        title: 'Banner title',
      },
    },
    {
      id: 2,
      title: '[FROM DS] Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 1,
      rating: {
        value: 2.1,
        total: 174,
      },
      hotelLink: '#hotelLink',
      reserveBtnUrl: 'https://html.adagio.adyax-dev.com/first-step.html',
      coordinates: {
        lat: 52.0981281,
        lng: 23.7536332,
      },
      images: [
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/884/88488112.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/884/88488108.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/884/88488110.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/885/88570091.jpg',
        },
      ],
      featureImages: [
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
      ],
      price: '23.80€',
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: false,
      unavailableText: 'No appartement available for those dates',
      isFavorite: false,
      offerBanner: {},
    },
    {
      id: 7,
      title: '[FROM DS] Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 4,
      rating: {
        value: 14.1,
        total: 174,
      },
      hotelLink: '#hotelLink',
      coordinates: {
        lat: 32.0873411,
        lng: 23.7181852,
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      featureImages: [
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
      ],
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: false,
      unavailableText: 'No appartement available for those dates',
    },
    {
      id: 8,
      title: '[FROM DS] Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 4,
      rating: {
        value: 14.1,
        total: 174,
      },
      hotelLink: '#hotelLink',
      coordinates: {
        lat: 48.0873411,
        lng: 23.7181852,
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      featureImages: [
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
      ],
      price: '2222.80€',
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: false,
      unavailableText: 'No appartement available for those dates',
    }],
  switchMapLinkText: {
    map: 'Map',
    list: 'List view',
  },
}, ['drupalSettings', 'searchResults'], window)

export const destinationMapIcon = pathOr({
  src: '/hero/icon-map.svg',
  alt: 'alt',
  title: 'title',
}, ['drupalSettings', 'destination', 'mapIcon'], window)

export const cardPopin = pathOr({
  title: 'Code de sécurité de votre carte bancaire',
  subtitle: 'Ou trouver le code de sécurité de votre carte bancaire?',
  description: 'Si vous utilisez une carte bancaire de type Visa ou Mastercard, vous trouverez le code de sécurité à 3 chiffres au verso de votre carte, le long de l’espace pour votre signature. Si vous utilisez une American Express, le code de sécurité est composé de 4 chiffres. Il est situé au recto de votre carte, au dessu de votre numéro de carte. Ce controle suplémentaire permet de vérifier que votre carte n’est pas utilisée de manière frauduleuse.',
  image: {
    src: 'https://www.ahstatic.com/photos/6788_ho_00_p_346x260.jpg',
    title: 'card popUp img title',
    alt: 'card popUp img alt',
  },
  tooltip: 'Learn more',
}, ['drupalSettings', 'secondStep', 'cardPopin'], window)

export const businessCodeFilter = pathOr({
  [SEARCH_PARAM_CLIENT_CODE]: 'SCP489754',
  [SEARCH_PARAM_CONTRACT_NUMBER]: 'AI366FR318',
  [SEARCH_PARAM_IATA_CODE]: '',
}, ['drupalSettings', 'businessCodeFilter'], window)

export const bookingAttemptOut = pathOr(null, ['drupalSettings', 'bookingAttemptOut'], window)
